import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { looseString } from '../common/util/SearchParams'
import { FormTemplateMatch } from '../components/form-template-match/FormTemplateMatch'

export const Route = createFileRoute('/_a/templates/match')({
  component: FormTemplateMatch,
  validateSearch: z.object({
    formTemplateId: looseString.optional(),
    useOriginalFile: z.boolean().optional(),
  }),
})
